import React from 'react';

import withPageComponents from '../../page/components/with-page-components';
import SeoMeta from '../../page/components/seo-meta';

const mapSEOData = (finderResults, seo, location) => {
    const { vwaDetails } = finderResults || {};
    const { totalProducts, products } = vwaDetails || {};
    const { search } = location || {};
    const isSortUrl = (search || '').includes('orderBy=');
    const robotsNoIndex = seo.robots || totalProducts * 1 === 0 || isSortUrl;
    const firstProduct = products?.[0]?.results?.length > 0 ? products?.[0]?.results?.[0] : products?.[0];

    const firstProductImage = firstProduct?.images?.[0]?.image;
    const ogData = {
        title: seo.title || seo.h1Tag,
        description: seo.description,
        url: seo.canonical,
        ...(firstProductImage ? { image: firstProductImage } : {}),
    };

    const { canonical, ...restSEO } = seo || {};
    return {
        ...restSEO,
        canonical: !robotsNoIndex ? canonical : undefined,
        robots: robotsNoIndex,
        ogData,
    };
};

export default withPageComponents(
    ({ finderResults, seo, location }) => {
        return (
            <SeoMeta
                seo={mapSEOData(finderResults, seo || {}, location)}
                enableDefaultCanonical={false}
                enableRobotsControl={true}
            />
        );
    },
    { components: ['finderResults'], seo: true, location: true },
);
